import BelegButtonVersionsvergleichBetragsrechnerTableRow
  from "../../BelegButtonVersionsvergleichBetragsrechnerTableRow/BelegButtonVersionsvergleichBetragsrechnerTableRow.vue";
import FormElementReadOnly from "../../../../../../global/components/FormElement/FormElementReadOnly/FormElementReadOnly.vue";
import PuxTranslate from "../../../../../../global/components/PuxTranslate/PuxTranslate.vue";
import SnapshotIcon from "../../../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";

import Honorarkostenrechner from "../../../../../KF/Betragsrechner/Honorarkostenrechner/Honorarkostenrechner";

// @vue/component
export default {
  name: "HonorarkostenrechnerBelegVergleich",
  components: {
    BelegButtonVersionsvergleichBetragsrechnerTableRow,
    FormElementReadOnly,
    PuxTranslate,
    SnapshotIcon,
  },
  mixins: [
    Honorarkostenrechner,
  ],
  props: {
    modelErfasst: {
      type: Object,
      required: true,
    },
    modelAnerkannt: {
      type: Object,
      required: true,
    },
  },
};
